/* eslint-disable no-unused-vars,no-unused-vars,no-undef */
// import { createCookie } from 'Hybrid/_cookies.js'
import './polyfills'
import algoliasearch from 'algoliasearch'
import Flickity from 'flickity'
import 'flickity-imagesloaded'
import map from './map'
import easylineCalculator from './easyline_calculator'
import ScrollTo from './scrollto'
import axios from 'axios'
import rightHeight from 'right-height'
import * as Share from './share'
import Cookie from './cookies'
import faqAccordion from './faq-accordion'

let newIndex

/* FAQ ACCORDION */
faqAccordion()
/* END FAQ ACCORDION */

/* Height match */
rightHeight.init({
  after: container => {
    if (container.parentNode.classList.contains('show')) {
      container.parentNode.classList.add('js-height-set')
    }
  }
})

function reinitHeightMatch (containerSelector = false) {
  let resizeContainer

  if (containerSelector) {
    resizeContainer = document.querySelector(
      containerSelector + ':not(.js-height-set)'
    )
  } else {
    resizeContainer = document.querySelector(
      `*[data-right-height]:not(.js-height-set)`
    )
  }
  if (resizeContainer) {
    resizeContainer.classList.add('js-height-set')
    rightHeight.adjustContainerHeight(resizeContainer)
  }
}

/* End height match */

/* Start Easyline Calculator */
let easylineCalculatorEl = document.querySelector('.js-easyline-calculator')
if (easylineCalculatorEl) {
  easylineCalculator().init(easylineCalculatorEl)
}
/* End Easyline Calculator */

/* START scrollto code */
ScrollTo().init()
;[...document.querySelectorAll('.js-scroll-to')].forEach(
  $btn => new ScrollTo($btn)
)
/* END scrollto code */

/* START Nav toggle code */
let body = document.querySelector('body')

function toggleMenu (
  $element,
  toggleClass,
  eventType,
  additionalFunc,
  $secondEl = null
) {
  let $toggleEl = $element

  if ($secondEl !== null) {
    $toggleEl = $secondEl
  }

  if ($toggleEl) {
    $toggleEl.addEventListener(eventType, e => {
      e.preventDefault()
      $element.classList.toggle(toggleClass)
      body.classList.toggle(toggleClass)

      if (additionalFunc) {
        additionalFunc()
      }
    })
  }
}

// const $nav = document.querySelector('.js-nav-main')
const $navToggle = document.querySelector('.js-nav-toggle')

/* Body lock taken from Audatex */
const lock = className => {
  let top = document.documentElement.scrollTop
  if (top === 0) {
    top = document.body.scrollTop
  }

  document.body.style.top = `${-top}px`
  document.body.classList.add('locked')
  className && document.body.classList.add(className)
}

const unlock = className => {
  const foo = -parseInt(document.body.style.top, 10)
  document.body.style.top = ''
  document.body.classList.remove('locked')
  className && document.body.classList.remove(className)
  window.scrollBy(0, foo)
}

$navToggle &&
  $navToggle.addEventListener('click', () => {
    const expanded = $navToggle.getAttribute('aria-expanded') === 'true'

    if (expanded) {
      $navToggle.setAttribute('aria-expanded', 'false')
      unlock('nav-open')
    } else {
      $navToggle.setAttribute('aria-expanded', 'true')
      lock('nav-open')
    }
  })

toggleMenu($navToggle, 'js-nav-open', 'click', () => {
  document.body.classList.toggle('js-nav-lock')

  if (!document.body.classList.contains('js-nav-lock')) {
    document.body.style.top = `${-document.documentElement.scrollTop}px`
  } else {
    document.body.style.top = ''
  }
})
/* END Nav toggle code */

/* Start select campaign */
let selectProducts = document.querySelectorAll('.js-select-product-info-hover')
/* End Select campaign */

/** * START Knowledge Centre ***/
const token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found.')
}

/* START - Knowledge Centre Tabs (e.g. Brochures, Videos etc.) */
let $toggleHeadings = [...document.querySelectorAll('.js-toggle-heading')]
let $toggleTargets = [...document.querySelectorAll('.js-tabbed-content')]

window.kb = {
  baseAjaxUrl: '/knowledge-centre/getArticles',
  selectedModel: {
    rocol: undefined,
    jelt: undefined,
    kema: undefined
  },
  page: 1,
  filters: {
    application: [],
    brand: [],
    industry: [],
    market: []
  }
}

const getParams = function (url) {
  let params = {}
  let parser = document.createElement('a')
  parser.href = url
  let query = parser.search.substring(1)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    params[pair[0]] = decodeURIComponent(pair[1])
  }
  return params
}

const generateKBAjaxUrl = () => {
  let url = window.kb.baseAjaxUrl
  let data = {}

  // Add the current model/type (e.g. brochure etc.)
  if (
    typeof window.kb.selectedModel[siteName] !== 'undefined' &&
    window.kb.selectedModel[siteName]
  ) {
    data.type = window.kb.selectedModel[siteName]
  }

  // Add the desired page
  if (typeof window.kb.page !== 'undefined' && window.kb.page) {
    if (
      typeof window.kb.selectedModel[siteName] !== 'undefined' &&
      window.kb.selectedModel[siteName]
    ) {
      let dashSeparatedModel = window.kb.selectedModel[siteName].replace(
        '_',
        '-'
      )
      data[dashSeparatedModel] = window.kb.page
    }
  }

  // Add the current filters
  const filters = window.kb.filters
  if (typeof filters !== 'undefined') {
    for (const model in filters) {
      if (filters[model] && filters[model].length > 0) {
        data[model] = filters[model].join(',')
      }
    }
  }
  const searchParams = new URLSearchParams(data)

  return url + '?' + searchParams.toString()
}

const switchTabs = newIndex => {
  const $tabs = [...document.querySelectorAll('.js-toggle-heading')]
  const $tabbedContents = [...document.querySelectorAll('.js-tabbed-content')]
  if ($tabs && $tabbedContents) {
    $tabs.forEach($tab => {
      const tabIndex = parseInt($tab.getAttribute('data-tab-select'), 10)
      if (tabIndex === newIndex) {
        $tab.classList.add('selected')
      } else {
        $tab.classList.remove('selected')
      }
    })
    $tabbedContents.forEach($tabbedContent => {
      const tabIndex = parseInt(
        $tabbedContent.getAttribute('data-content-tab'),
        10
      )
      if (tabIndex === newIndex) {
        $tabbedContent.classList.add('show')
      } else {
        $tabbedContent.classList.remove('show')
      }
    })

    reinitHeightMatch(`.js-tabbed-content.show[data-content-tab="${newIndex}"]`)
  }
}

const updateKnowledgeBase = () => {
  const ajaxUrl = generateKBAjaxUrl()

  const $filterableContent = document.querySelector('.js-filterable-content')
  const $currentHeading = document.querySelector(
    `.js-toggle-heading[data-slug="${window.kb.selectedModel[siteName]}"]`
  )
  const $currentTab = document.querySelector(
    `.js-tabbed-content[data-content-tab="${
      window.kb.selectedModel[siteName]
    }"]`
  )

  if (window.kb.selectedModel[siteName] === 'featured') {
    if ($filterableContent) {
      $filterableContent.classList.remove('show')
    }
    if ($toggleHeadings) {
      $toggleHeadings.forEach($el => {
        $el.classList.remove('selected')
      })
    }
    if ($toggleTargets) {
      $toggleTargets.forEach($el => {
        $el.classList.remove('show')
      })
    }
    if ($currentHeading) {
      $currentHeading.classList.add('selected')
    }
    if ($currentTab) {
      $currentTab.classList.add('show')
    }

    reinitHeightMatch(
      `.js-tabbed-content.show[data-content-tab="${
        window.kb.selectedModel[siteName]
      }"]`
    )
  } else {
    if ($toggleTargets) {
      $toggleTargets
        .filter($toggleTarget => {
          return (
            $toggleTarget.hasAttribute('data-content-tab') &&
            $toggleTarget.getAttribute('data-content-tab') !== 'featured'
          )
        })
        .forEach($el => {
          if ($el.children[0]) $el.children[0].classList.add('opacity-25')
        })
    }

    axios
      .get(ajaxUrl)
      .then(function (response) {
        const $tabContent = document.querySelector(
          `.js-tabbed-content[data-content-tab="${
            window.kb.selectedModel[siteName]
          }"]`
        )
        const $filterableContent = document.querySelector(
          '.js-filterable-content'
        )

        // handle success
        if ($toggleHeadings) {
          $toggleHeadings.forEach($el => {
            $el.classList.remove('selected')
          })
        }
        if ($toggleTargets) {
          $toggleTargets.forEach($el => {
            $el.classList.remove('show')
          })
        }

        const $tabToSelect = document.querySelector(
          `.js-toggle-heading[data-singular-model="${
            window.kb.selectedModel[siteName]
          }"]`
        )
        if ($tabToSelect) {
          $tabToSelect.classList.add('selected')
        }

        if ($tabContent) {
          $tabContent.innerHTML = response.data
        }
        if ($filterableContent) {
          $filterableContent.classList.add('show')
        }

        let $paginationLinks
        if ($tabContent) {
          $paginationLinks = [...$tabContent.querySelectorAll('.pagination a')]
        }
        if ($paginationLinks) {
          $paginationLinks.forEach($paginationLink => {
            $paginationLink.addEventListener('click', e => {
              e.preventDefault()

              let url = e.target.getAttribute('href')
              url = new URL(url)
              let dashSeparatedModel = ''
              if (
                typeof window.kb.selectedModel[siteName] !== 'undefined' &&
                window.kb.selectedModel[siteName]
              ) {
                dashSeparatedModel = window.kb.selectedModel[siteName].replace(
                  '_',
                  '-'
                )
              }
              window.kb.page = url.searchParams.get(dashSeparatedModel)

              updateKnowledgeBase()
            })
          })
        }

        let $toggleSpecifiedTargets = [
          ...document.querySelectorAll(
            `.js-tabbed-content[data-content-tab="${
              window.kb.selectedModel[siteName]
            }"]`
          )
        ]
        if ($toggleSpecifiedTargets) {
          $toggleSpecifiedTargets.forEach($el => {
            $el.classList.add('show')
          })
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
      .then(function () {
        // always executed
        reinitHeightMatch(
          `.js-tabbed-content.show[data-content-tab="${
            window.kb.selectedModel[siteName]
          }"]`
        )
      })
  }
}

// Set up tab events
if ($toggleHeadings) {
  $toggleHeadings.forEach($el => {
    $el.addEventListener('click', e => {
      e.preventDefault()

      if (
        typeof window.isKnowledgeBase !== 'undefined' &&
        window.isKnowledgeBase
      ) {
        window.kb.page = 1
        window.kb.selectedModel[siteName] = $el.getAttribute(
          'data-singular-model'
        )
          ? $el.getAttribute('data-singular-model')
          : ''
        updateKnowledgeBase()
      } else {
        newIndex = parseInt(e.target.getAttribute('data-tab-select'), 10)
        switchTabs(newIndex)
      }
    })
  })
}

// Set up filter checkbox events
const $filterableContentCheckboxes = [
  ...document.querySelectorAll('.js-filterable-content-checkbox')
]
if ($filterableContentCheckboxes) {
  $filterableContentCheckboxes.forEach($cbx => {
    $cbx.addEventListener('change', e => {
      const $checkbox = e.target
      let name = $checkbox.getAttribute('name')
      if (name) name = name.split('_')
      const model = name[0]
      const id = name[1]

      if ($checkbox.checked && !window.kb.filters[model].includes(id)) {
        window.kb.filters[model].push(id)
      } else if (!$checkbox.checked && window.kb.filters[model].includes(id)) {
        for (let i = 0; i < window.kb.filters[model].length; i++) {
          if (window.kb.filters[model][i] === id) {
            window.kb.filters[model].splice(i, 1)
            break
          }
        }
      }
      updateKnowledgeBase()
    })
  })
}

const $resettableForms = [
  ...document.querySelectorAll('.js-filterable-content')
]
if ($resettableForms) {
  $resettableForms.forEach($resettableForm => {
    $resettableForm.addEventListener('reset', e => {
      for (const [key, value] of Object.entries(window.kb.filters)) {
        window.kb.filters[key] = []
      }
      updateKnowledgeBase()
    })
  })
}

if (typeof window.isNewsIndex !== 'undefined' && window.isNewsIndex) {
  let queryParams = getParams(window.location.href)
  let tabToShow = queryParams.tab
  const $currentHeading = document.querySelector(
    `.js-toggle-heading[data-slug="${tabToShow}"]`
  )
  if ($currentHeading && $currentHeading.getAttribute('data-tab-select')) {
    newIndex = parseInt($currentHeading.getAttribute('data-tab-select'), 10)
    switchTabs(newIndex)
  }
} else if (
  typeof window.isKnowledgeBase !== 'undefined' &&
  window.isKnowledgeBase
) {
  // Figure out which tab we're supposed to be on and populate the knowledge base accordingly
  let queryParams = getParams(window.location.href)
  let tabToShow = queryParams.tab
  if (!tabToShow || tabToShow === undefined || tabToShow.length < 1) {
    window.kb.selectedModel[siteName] = 'featured'
  } else {
    tabToShow = tabToShow.replace('-', '_')

    // If it's just a case of removing an 's', no need to define here
    const singularFromPlural = {
      case_studies: 'case_study'
    }
    if (tabToShow in singularFromPlural) {
      tabToShow = singularFromPlural[tabToShow]
    } else {
      tabToShow = tabToShow.slice(0, -1)
    }
    window.kb.selectedModel[siteName] = tabToShow
  }
  updateKnowledgeBase()
} else {
  // We have tabs on other pages than the Knowledge Base
  switchTabs(0)
}

/** * END Knowledge base ***/

/** Reusable accordion logic */
const $accordions = [...document.querySelectorAll('.js-accordion')]
if ($accordions) {
  $accordions.forEach($accordion => {
    const $btn = $accordion.querySelector('.js-accordion-btn')
    const $content = $accordion.querySelector('.js-accordion-content')
    $btn.addEventListener('click', e => {
      const isOpen = $accordion.classList.contains('expanded')
      if (isOpen) {
        $accordion.classList.remove('expanded')
      } else {
        $accordion.classList.add('expanded')
      }
    })
  })
}

/** End Reusable accordion logic */

/* START FILTER */
let $filterSelects = [...document.querySelectorAll('.js-filter-select')]
let $filterOptions = [...document.querySelectorAll('.js-filter-option')]

// Close dropdowns on clicks elsewhere?
document.querySelector('html').addEventListener('click', e => {
  $filterSelects.forEach(el => {
    if (!el.parentNode.classList.contains('overflow-hidden')) {
      el.parentNode.classList.add('overflow-hidden')
    }
  })
})

// Click js-filter-select
$filterSelects.forEach(el => {
  // Remove overflow from parent js-filter-display
  el.addEventListener('click', e => {
    e.stopPropagation()
    el.parentNode.classList.toggle('overflow-hidden')
    const $span = el.querySelector('span')
    if ($span.innerHTML !== $span.getAttribute('data-default')) {
      el.parentNode.parentNode.querySelector('input').value = $span.innerHTML
    }
  })
})

// Click js-filter-option
$filterOptions.forEach(el => {
  // Replace js-filter-select inner span text with the dropdown
  el.addEventListener('click', e => {
    e.stopPropagation()
    // Grab selected filter value
    let clickedEl = e.currentTarget

    // Grab currently selected val (could be default/filter title)
    let selectedValEl = el.parentNode.parentNode.parentNode.querySelector(
      'span'
    )

    // Set filter item selected states
    Array.from(
      el.parentNode.parentNode.querySelectorAll('.js-filter-option')
    ).forEach(el => {
      el.classList.remove('selected')
    })
    clickedEl.classList.add('selected')

    if (el.parentNode.parentNode.parentNode.parentNode.querySelector('input')) {
      el.parentNode.parentNode.parentNode.parentNode.querySelector(
        'input'
      ).value = clickedEl.innerHTML.trim()
    }

    // Reveal reset
    document.querySelector('.js-filter-reset').classList.remove('hidden')

    // Hide dropdown
    el.parentNode.parentNode.parentNode.classList.add('overflow-hidden')
    if (clickedEl.innerHTML === selectedValEl.innerHTML) {
      selectedValEl.innerHTML = clickedEl.getAttribute('data-default')
    } else {
      selectedValEl.innerHTML = clickedEl.innerHTML
    }

    let filterName = el.parentNode.parentNode.parentNode.parentNode.querySelector(
      'input'
    ).name

    switch (filterName) {
      // Product filters
      case 'industry_filter':
      case 'application_filter':
      case 'brand_filter':
        productFilter(filterName, e.currentTarget)
        break

      // Distributors filters
      case 'distributor_industry_filter':
      case 'distributor_brand_filter':
      case 'distributor_country_filter':
        distributorFilter(filterName, e.currentTarget)
        break

      // Datasheet filters
      case 'datasheet_language_filter':
      case 'datasheet_type_filter':
        datasheetFilter(filterName, e.currentTarget)
        break
    }
  })
})

if (
  Array.from(document.querySelectorAll('.datasheet-filter-form')).length > 0
) {
  document
    .querySelector('.datasheet-filter-form')
    .addEventListener('submit', e => {
      e.preventDefault()
      getDatasheets()
    })
}

if (window.location.href.match(/\/products\?/)) {
  // Auto-select product filters
  let query = window.location.search.substring(1)
  let queryParts = query.split('&')

  queryParts.forEach(p => {
    let q = p.split('=')

    if (q[1]) {
      switch (q[0]) {
        case 'industry_id':
          productFilter(
            'industry_filter',
            document
              .querySelector('[data-filter=industry_filter]')
              .querySelector('button[data-filter-id="' + q[1] + '"]'),
            q[1],
            true
          )
          break
        case 'application_id':
          productFilter(
            'application_filter',
            document
              .querySelector('[data-filter=application_filter]')
              .querySelector('button[data-filter-id="' + q[1] + '"]'),
            q[1],
            true
          )
          break
        case 'brand_id':
          productFilter(
            'brand_filter',
            document
              .querySelector('[data-filter=brand_filter]')
              .querySelector('button[data-filter-id="' + q[1] + '"]'),
            q[1],
            true
          )
          break
      }
    }
  })
}

/*
if (location.href.match(/\/datasheets(.*)/)) {
  // Auto-select datasheet filters
  let query = location.search.substring(1)
  let queryParts = query.split('&')

  queryParts.forEach(p => {
    let q = p.split('=')
    console.log(q)
    if (q[1]) {
      switch (q[0]) {
        case 'datasheet_language_filter':
          datasheetFilter(
            'datasheet_language_filter',
            document
              .querySelector('[data-filter=datasheet_language_filter]')
              .querySelector('button[data-filter-id="' + q[1] + '"]'),
            q[1],
            true
          )
          break
        case 'datasheet_type_filter':
          datasheetFilter(
            'datasheet_type_filter',
            document
              .querySelector('[data-filter=datasheet_type_filter]')
              .querySelector('button[data-filter-id="' + q[1] + '"]'),
            q[1],
            true
          )
          break
      }
    }
  })
}
*/

function productFilter (name, currentTarget, value, skipAJAX) {
  window.brandsIds = []
  if (value) {
    let selectedButton = document
      .querySelector('[data-filter=' + name + ']')
      .querySelector('button[data-filter-id="' + value + '"]')

    if (selectedButton) {
      let selectedValueLabel = selectedButton.innerHTML.trim()
      document
        .querySelector('[data-filter="' + name + '"]')
        .querySelector('span[data-default]').innerHTML = selectedValueLabel
      document.querySelector('[name="' + name + '"]').value = value
    }
  }

  let targetFilters = Array.from({
    industry_filter: ['application_filter', 'brand_filter'],
    application_filter: ['brand_filter']
  })

  let filterId = currentTarget.getAttribute('data-filter-id')

  document.querySelector('[name=' + name + ']').value = filterId

  if (targetFilters[name]) {
    targetFilters[name].forEach(targetFilter => {
      let filter = document.querySelector('[data-filter=' + targetFilter + ']')
      let $filterOptions = Array.from(filter.querySelectorAll('li'))

      // Reset default options
      let displaySpan = filter
        .querySelector('.js-filter-select')
        .querySelector('span')
      displaySpan.innerHTML = displaySpan.getAttribute('data-default')

      // Reset hidden input field
      document.querySelector('[name=' + targetFilter + ']').value = ''

      $filterOptions.forEach(element => {
        element.classList.add('hidden')
      })
      Array.from(
        filter.querySelectorAll(
          '[data-parent-filter-ids*="|' + filterId + '|"]'
        )
      ).forEach(element => {
        if (targetFilter === 'brand_filter') {
          if (
            window.brandsIds.indexOf(
              parseInt(element.getAttribute('data-filter-id'))
            ) >= 0
          ) {
            element.classList.remove('hidden')
          }
        } else {
          element.classList.remove('hidden')
        }
      })
    })
  }

  if (!skipAJAX) {
    getProducts()
  }
}

function distributorFilter (name, currentTarget, value, skipAJAX) {
  if (value) {
    let selectedButton = document
      .querySelector('[data-filter=' + name + ']')
      .querySelector('[data-filter-id="' + value + '"]')

    if (selectedButton) {
      let selectedValueLabel = selectedButton.innerHTML.trim()
      document
        .querySelector('[data-filter="' + name + '"]')
        .querySelector('span[data-default]').innerHTML = selectedValueLabel
      document.querySelector('[name="' + name + '"]').value = value
    }
  }

  var targetFilters = {
    distributors_industry_filter: 'distributors_brand_filter'
  }

  var filterId = currentTarget.getAttribute('data-filter-id')

  document.querySelector('[name=' + name + ']').value = filterId

  if (targetFilters[name]) {
    var filter = document.querySelector(
      '[data-filter=' + targetFilters[name] + ']'
    )
    var $filterOptions = filter.querySelectorAll('li')

    // Reset default options
    var displaySpan = filter
      .querySelector('.js-filter-select')
      .querySelector('span')
    displaySpan.innerHTML = displaySpan.getAttribute('data-default')

    Array.from($filterOptions).forEach(element => {
      element.classList += ' hidden'
    })
    Array.from(
      filter.querySelectorAll('[data-parent-filter-ids*="|' + filterId + '|"]')
    ).forEach(element => {
      element.classList.remove('hidden')
    })
    filter.querySelector('.js-filter-select').click()
  }

  if (!skipAJAX) {
    getDistributors()
  }
}

function datasheetFilter (name, currentTarget, value, skipAJAX) {
  if (value) {
    let selectedButton = document
      .querySelector('[data-filter=' + name + ']')
      .querySelector('button[data-filter-id="' + value + '"]')

    if (selectedButton) {
      let selectedValueLabel = selectedButton.innerHTML.trim()
      document
        .querySelector('[data-filter="' + name + '"]')
        .querySelector('span[data-default]').innerHTML = selectedValueLabel
      document.querySelector('[name="' + name + '"]').value = value
    }
  }

  var filterId = currentTarget.getAttribute('data-filter-id')

  document.querySelector('[name=' + name + ']').value = filterId

  getDatasheets()
}

function getProducts () {
  let industryId = document.querySelector('[name=industry_filter]').value
  let applicationId = document.querySelector('[name=application_filter]').value
  let brandId = document.querySelector('[name=brand_filter]').value
  let scope = document.querySelector('[name=product_scope]').content

  axios
    .get(
      `/${scope ||
        'products'}/filter?industry_id=${industryId}&application_id=${applicationId}&brand_id=${brandId}&page=1`
    )
    .then(function (response) {
      // handle success
      document.getElementById('filter-results').innerHTML = response.data.html
      window.brandsIds = response.data.brands

      if (response.data.brands) {
        response.data.brands.forEach(function (brandId) {
          document
            .querySelector('[data-filter=brand_filter]')
            .querySelector('[data-filter-id="' + brandId + '"]')
            .classList.remove('hidden')
        })
      }
    })
    .catch(function (error) {
      // handle error
      console.log(error)
    })
    .then(function () {
      // always executed
      reinitHeightMatch()
    })
}

function getDistributors () {
  let industryId = document.querySelector('[name=distributor_industry_filter]')
    .value
  let brandId = document.querySelector('[name=distributor_brand_filter]').value
  let countryId = document.querySelector('[name=distributor_country_filter]')
    .value
  let scope = document.querySelector('[name=distributors_scope]').content

  axios
    .get(
      `/${scope ||
        'distributors'}/filter?industry_id=${industryId}&brand_id=${brandId}&country_id=${countryId}&page=1`
    )
    .then(function (response) {
      // handle success
      document.getElementById('filter-results').innerHTML = response.data
    })
    .catch(function (error) {
      // handle error
      console.log(error)
    })
    .then(function () {
      // always executed
      reinitHeightMatch()
      attachDistributorWatcher()
    })
}

function getDatasheets () {
  let scope = document.querySelector('[name=datasheets_scope]').content
  var languageId = document.querySelector('[name=datasheet_language_filter]')
    .value
  // var typeId = document.querySelector('[name=datasheet_type_filter]').value
  var searchQuery = document.getElementById('datasheet-filter-search').value

  axios
    .get(
      `/${scope ||
        'datasheets'}/filter?language_id=${languageId}&query=${searchQuery}&page=1`
    )
    .then(function (response) {
      // handle success
      document.getElementById('filter-results').innerHTML = response.data.html
    })
    .catch(function (error) {
      // handle error
      console.log(error)
    })
    .then(function () {
      // always executed
      reinitHeightMatch()
    })
}
/* END FILTER */

/* START FOCUS HELPER */
// Making focus click a bit nicer in contact form.
let inputGroup = [...document.querySelectorAll('.js-focus-helper')]

inputGroup.forEach(el => {
  el.addEventListener('click', e => {
    e.currentTarget.querySelector('input, textarea').focus()
  })
})
/* END FOCUS HELPER */

/* START FLICKITY */

let flickityContainers = [...document.querySelectorAll('.js-flickity')]
flickityContainers.forEach(el => {
  // eslint-disable-next-line no-unused-vars
  let flickity = new Flickity(el, {
    autoPlay: false,
    imagesLoaded: true
  })
})

/* END FLICKITY */

// TODO: Split out below functionality into new file
/* START MAIN NAV SEARCH FUNC */

// hs = headerSearch
let hsContainer = document.querySelector('.js-hs')
let hsInput = document.querySelector('.js-hs-input')
let hsOpenBtns = [...document.querySelectorAll('.js-hs-open')]
let hsClose = document.querySelector('.js-hs-close')
let hsInputMirrorContainer = document.querySelector(
  '.js-hs-input-mirror-container'
)
let hsInputMirror = document.querySelector('.js-hs-input-mirror')
let hsSearchResultsContainer = document.querySelector('.js-hs-results')

const algoliaAppId = document.querySelector('[name=algolia_app_id]').content
const algoliaSearch = document.querySelector('[name=algolia_search]').content

let client = algoliasearch(algoliaAppId, algoliaSearch)
let productsIndexName = window.algoliaEnv + '_products'
let datasheetsIndexName = window.algoliaEnv + '_datasheets'
let newsIndexName = window.algoliaEnv + '_news'

let productsIndex = client.initIndex(productsIndexName)
let datasheetsIndex = client.initIndex(datasheetsIndexName)
let newsIndex = client.initIndex(newsIndexName)

let closeSearch = function () {
  document.body.classList.remove('js-search-open')
  hsContainer.classList.remove('show')
  hsInputMirrorContainer.classList.remove('show')
  hsSearchResultsContainer.classList.remove('show')
  hsInput.value = ''
  hsInputMirror.innerHTML = ''
}

let searchPopulate = function (results, category) {
  let scope = document.querySelector('[name=datasheets_scope]').content

  let resultLists = [
    ...document.querySelectorAll(
      '.js-result-list[data-category="' + category + '"]'
    )
  ]

  // Check if results are empty via loop, if so change search population behaviour (remove elements)
  let empty = true
  // eslint-disable-next-line no-unused-vars
  for (let result in results) {
    empty = false
  }

  if (!empty) {
    if (
      !hsSearchResultsContainer.classList.contains('show') &&
      hsInput.value !== ''
    ) {
      hsSearchResultsContainer.classList.add('show')
    }

    resultLists.forEach(resultList => {
      let resultListItems = [...resultList.querySelectorAll('li')]

      resultListItems.forEach(resultListItem => {
        if (!resultListItem.classList.contains('js-no-remove')) {
          resultListItem.parentNode.removeChild(resultListItem)
        }
      })
    })

    // TODO: Put each case into a single function so no repeating
    // TODO: Link correctly to search results
    results = Array.from(results)
    for (let i = results.length - 1; i >= 0; i--) {
      let result = results[i]
      // find the category parent element and show it
      switch (category) {
        case 'Products':
          let productEl = document.createElement('li')
          let productLink = document.createElement('a')
          productLink.href = result.url
          productEl.appendChild(productLink)
          productLink.innerHTML = result.title
          document
            .querySelector('.js-product-result-list')
            .appendChild(productEl)
          break
        case 'Datasheets':
          let datasheetEl = document.createElement('li')
          let datasheetLink = document.createElement('a')
          console.log(result)
          datasheetLink.href = `/${scope}/download/${result.type}/${
            result.datasheet_language_id
          }/${result.name}`
          datasheetEl.appendChild(datasheetLink)
          datasheetLink.innerHTML = `${result.name} - ${
            result.datasheet_language
          }`
          document
            .querySelector('.js-datasheet-result-list')
            .appendChild(datasheetEl)
          break
        case 'News':
          let newsEl = document.createElement('li')
          let newsLink = document.createElement('a')
          newsLink.href = result.url
          newsEl.appendChild(newsLink)
          newsLink.innerHTML = result.title
          document.querySelector('.js-news-result-list').appendChild(newsEl)
          break
        default:
          // statements_def
          break
      }
    }

    resultLists.forEach(resultList => {
      if (resultList.childElementCount > 1) {
        resultList.parentNode.classList.add('show')
      } else {
        resultList.parentNode.classList.remove('show')
      }
    })
  }
}

function throttle (func, wait = 1000) {
  let timer = null
  return function (...args) {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, args)
        timer = null
      }, wait)
    }
  }
}

function searchCb (err, content) {
  if (err) throw err

  let productResults = []
  let datasheetResults = []
  let newsResults = []

  // TODO: Put each case into a single function so no repeating
  if (content.hits) {
    switch (content.indexUsed) {
      case productsIndexName:
        for (let i = content.hits.length - 1; i >= 0; i--) {
          let productResult = content.hits[i]

          productResults.push(productResult)
        }
        break
      case datasheetsIndexName:
        for (let i = content.hits.length - 1; i >= 0; i--) {
          let datasheetResult = content.hits[i]

          datasheetResults.push(datasheetResult)
        }
        break
      case newsIndexName:
        for (let i = content.hits.length - 1; i >= 0; i--) {
          let newsResult = content.hits[i]

          newsResults.push(newsResult)
        }
        break
      default:
        console.log('No content found')
        break
    }
    // console.log('productResults')
    // console.log(productResults)
    searchPopulate(productResults, 'Products')
    searchPopulate(datasheetResults, 'Datasheets')
    searchPopulate(newsResults, 'News')
  }
}

// Open nav search bar
hsOpenBtns.forEach(el => {
  el.addEventListener('click', () => {
    document.body.classList.add('js-search-open')
    hsContainer.classList.add('show')
    hsInput.focus()
  })
})

// Close with close button and escape
if (hsClose) {
  hsClose.addEventListener('click', closeSearch)
  hsInput.onkeydown = function (e) {
    e = e || window.event
    let isEscape = false
    if ('key' in e) {
      isEscape = e.key === 'Escape' || e.key === 'Esc'
    } else {
      isEscape = e.keyCode === 27
    }
    if (isEscape) {
      closeSearch()
    }
  }
}

// Live search in nav
if (hsInput) {
  hsInput.addEventListener('keyup', e => {
    let el = e.target
    let value = el.value

    if (value !== '' && !hsInputMirrorContainer.classList.contains('show')) {
      hsInputMirrorContainer.classList.add('show')
      hsInputMirror.innerHTML = value
    } else if (value !== '') {
      hsInputMirror.innerHTML = value
    } else {
      hsInputMirrorContainer.classList.remove('show')
      hsSearchResultsContainer.classList.remove('show')
    }

    // TODO: Add throttle
    throttle(
      productsIndex.search(
        {
          query: value,
          getRankingInfo: true,
          hitsPerPage: 8
        },
        // eslint-disable-next-line handle-callback-err
        (function (err, content, category) {
          return function (err, content, category) {
            searchCb(err, content, category)
          }
        })()
      )
    )
    throttle(
      datasheetsIndex.search(
        {
          query: value,
          getRankingInfo: true,
          hitsPerPage: 8
        },
        // eslint-disable-next-line handle-callback-err
        (function (err, content, category) {
          return function (err, content, category) {
            console.log(new Date().toJSON(), content)
            searchCb(err, content, category)
          }
        })()
      )
    )
    throttle(
      newsIndex.search(
        {
          query: value,
          getRankingInfo: true,
          hitsPerPage: 8
        },
        // eslint-disable-next-line handle-callback-err
        (function (err, content, category) {
          return function (err, content, category) {
            searchCb(err, content, category)
          }
        })()
      )
    )
  })
}

/* END MAIN NAV SEARCH FUNC */

/* Start Google Map */
let mapEl = document.getElementById('map')
/* Google Maps */
if (mapEl) {
  map().init(mapEl)
}
/* End Google Map */

/* START DISTRIBUTOR OVERLAY */
function attachDistributorWatcher () {
  let overlayOpen = [...document.querySelectorAll('.js-distributor-more')]
  let overlayClose = [...document.querySelectorAll('.js-close-overlay')]

  overlayOpen.forEach(el => {
    el.addEventListener('click', () => {
      document
        .querySelector(
          '.js-overlay[data-overlay-id="' +
            el.getAttribute('data-overlay-selector') +
            '"]'
        )
        .classList.remove('hidden')
      lock('nav-open')
    })
  })

  overlayClose.forEach(el => {
    el.addEventListener('click', () => {
      document
        .querySelector(
          '.js-overlay[data-overlay-id="' +
            el.getAttribute('data-overlay-selector') +
            '"]'
        )
        .classList.add('hidden')
      unlock('nav-open')
    })
  })
}

attachDistributorWatcher()

/* END DISTRIBUTOR OVERLAY */

/* SOCIAL SHARE STARTS */
let shareContainer = document.querySelector('.js-share-container')

if (shareContainer) {
  Share.init()
}
/* SOCIAL SHARE END */

/* CHAT NOTICE */
// var $chatNotice = document.querySelector('.js-chat-info')
// var $closeChatNoticeBtn = document.querySelector('.js-chat-info-close')

// if (!Cookie().readCookie('hasSeenChatNotification')) {
//   Cookie().createCookie('hasSeenChatNotification', true)
//   if ($chatNotice) {
//     $chatNotice.classList.add('is-active')
//     $closeChatNoticeBtn.addEventListener('click', () => {
//       $chatNotice.classList.remove('is-active')
//     })
//   }
// }

/* END CHAT NOTICE */



// WEBPACK FOOTER //
// ./resources/assets/js/core/main.js